import { CommonModule } from '@angular/common';
import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { TitleService } from '../../services/title.service';

@Component({
  selector: 'app-slider-area',
  imports: [CommonModule],
  templateUrl: './slider-area.component.html',
  styleUrl: './slider-area.component.css'
})
export class SliderAreaComponent /* implements OnInit, OnDestroy */ {

showVideoModal = false;
  isMuted = true;

  // video associati agli sfondi
  videos = [
/*     'resources/video/trigoria.mp4', */
    'resources/video/palestra.mp4'
  ];

  // immagini di sfondo dello slider
  slides = [
/*     {
      bg: '/resources/img/gallery/trigoria.png',
      videoIndex: 0
    }, */
    {
      bg: '/resources/img/gallery/ironman.jpg',
      videoIndex: 0
    }
  ];

  currentSlide = 0;
  currentIndex = 0;
  slideIntervalId: any;

  @ViewChild('videoPlayer') videoPlayer!: ElementRef<HTMLVideoElement>;

  constructor(public router: Router, public ts: TitleService) {}

/*   ngOnInit(): void {
    this.startSlideAuto();
  }

  ngOnDestroy(): void {
    this.stopSlideAuto();
  } */

  openVideoModal(): void {
    // imposta quale video riprodurre
    console.log("OPEN");
    console.log(this.currentIndex);
    this.currentIndex = this.slides[this.currentSlide].videoIndex;

    this.showVideoModal = true;

    setTimeout(() => {
      this.videoPlayer?.nativeElement.play();
    }, 500);
  }

  closeVideoModal(): void {
    if (this.videoPlayer) {
      this.videoPlayer.nativeElement.pause();
    }
    this.showVideoModal = false;
  }

  // autoplay sfondi
/*   startSlideAuto() {
    this.slideIntervalId = setInterval(() => {
      this.nextSlide();
    }, 5000);
  }

  stopSlideAuto() {
    if (this.slideIntervalId) {
      clearInterval(this.slideIntervalId);
      this.slideIntervalId = null;
    }
  } */

  nextSlide(event?: MouseEvent) {
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }
    this.currentSlide = (this.currentSlide + 1) % this.slides.length;
  }

  prevSlide(event?: MouseEvent) {
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }
    this.currentSlide =
      (this.currentSlide - 1 + this.slides.length) % this.slides.length;
  }
}
